import { CHANNELS } from '@/models/dashboards/channels.enum';

export const MEDIA_TYPE_BREAKDOWN = Object.freeze({
  AD: { label: 'Ad', icon: 'ad' },
  ALL_MEDIA: { label: 'All Media', icon: 'all' },
  CAROUSEL: { label: 'Carousel', icon: 'carousel' },
  CAROUSEL_CONTAINER: { label: 'Carousel Container', icon: 'carousel' },
  DOCUMENT: { label: 'Document', icon: 'text' },
  IGTV: { label: 'IGTV', icon: 'tv' },
  IMAGE: { label: 'Image', icon: 'photo' },
  IMAGE_CAROUSEL: { label: 'Images + Carousels', icon: 'mixed' },
  LINK: { label: 'Link', icon: 'link' },
  LIVE: { label: 'Live', icon: 'live' },
  MULTI_IMAGE: { label: 'Multi Image', icon: 'mixed' },
  ON_DEMAND: { label: 'On Demand', icon: 'video' },
  PHOTO: { label: 'Photo', icon: 'photo' },
  PHOTO_CAROUSEL: { label: 'Photos + Carousels', icon: 'mixed' },
  POST: { label: 'Post', icon: 'photo' },
  REEL: { label: 'Reel', icon: 'reel' },
  SHORTS: { label: 'Shorts', icon: 'reel' },
  STORY: { label: 'Story', icon: 'story' },
  TEXT: { label: 'Text', icon: 'text' },
  VIDEO: { label: 'Video', icon: 'video' },
  VIDEO_REEL: { label: 'Videos + Reels', icon: 'mixed' },
});

export const VALID_ES_MEDIA_TYPES_BY_CHANNEL: Record<string, string[]> = {
  [CHANNELS.FACEBOOK.value]: ['carousel', 'link', 'photo', 'reel', 'text', 'video'],
  [CHANNELS.INSTAGRAM.value]: [
    'ALL_MEDIA',
    'carousel',
    'image',
    'image_carousel',
    'reel',
    'video',
    'video_reel',
  ],
  [CHANNELS.LINKEDIN.value]: ['DOCUMENT', 'IMAGE', 'LINK', 'MULTI_IMAGE', 'TEXT', 'VIDEO'],
  [CHANNELS.PINTEREST.value]: ['carousel', 'image', 'photo', 'video'],
  [CHANNELS.TIKTOK.value]: ['PHOTO', 'VIDEO'],
  [CHANNELS.TWITTER.value]: ['carousel', 'link', 'photo', 'text', 'video'],
  [CHANNELS.YOUTUBE.value]: ['LIVE', 'ON_DEMAND', 'SHORTS'],
};

export const VALID_DB_MEDIA_TYPES: Record<string, string[]> = {
  [CHANNELS.INSTAGRAM.value]: [
    'ALL_MEDIA',
    'AD',
    'CAROUSEL_CONTAINER',
    'IGTV',
    'LIVE',
    'POST',
    'STORY',
    'REEL',
  ],
};

export const LEGACY_TO_V2_MEDIA_TYPE_MAP: Record<string, Record<string, Record<string, string>>> = {
  ES: {
    [CHANNELS.INSTAGRAM.value]: {
      ALL_MEDIA: 'ALL_MEDIA',
      PHOTO: 'image',
      VIDEO: 'video',
      REEL: 'reel',
      CAROUSEL: 'carousel',
      PHOTO_CAROUSEL: 'image_carousel',
      VIDEO_REEL: 'video_reel',
    },
    [CHANNELS.FACEBOOK.value]: {
      ALL_MEDIA: 'ALL_MEDIA',
      CAROUSEL: 'carousel',
      PHOTO: 'photo',
      PHOTO_CAROUSEL: 'photo_carousel',
      VIDEO: 'video',
      REEL: 'reel',
      VIDEO_REEL: 'video_reel',
      LINK: 'link',
      STATUS: 'text',
    },
  },
  DB: {
    [CHANNELS.INSTAGRAM.value]: {
      ALL_MEDIA: 'ALL_MEDIA',
      AD: 'AD',
      IGTV: 'IGTV',
      LIVE: 'LIVE',
      POST: 'POST',
      STORY: 'STORY',
      REEL: 'REEL',
    },
  },
};
